import React from 'react'
import ChangelogInstance from '../ChangelogInstance';

const OneDotTwentyFiveDotOne = () => {
  return (
    <ChangelogInstance version="1.25.1" date="2020-01-27">
      <li>
        Made old.csgolounge.com permission that was prompting during update optional.
      </li>
    </ChangelogInstance>
  );
}

export default OneDotTwentyFiveDotOne;